import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "../Components/LandingPage/LandingPage";
import Booking from "../Components/Booking/Booking";
import Navbar from "../Components/Navbar/Navbar";
import Price from "./Price";

export default function RouterComponent() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" exact element={<LandingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/SchedulePickUp" element={<Booking />} />
        <Route path="/Price" element={<Price />} />
      </Routes>
    </>
  );
}
